import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { TabsPage } from '../tabs/tabs';
import { AuthService } from '../../providers/auth-service';
import { AuthStore } from '../../stores/auth-store';
import { ConstantsStore } from '../../stores/constants-store';
import { AbstractPage } from '../_com/abstract-page';
import { HttpConstantProvider } from '../../providers/http-constant';

/**
 * Generated class for the LoginPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage extends AbstractPage {

  data = {
    user_id: "",
    password: "",
  }

  constructor(public navCtrl: NavController, public navParams: NavParams, private authService: AuthService, private authStore: AuthStore, private httpConstantProvider: HttpConstantProvider, private constantsStore: ConstantsStore) {
    super();

    this.data.user_id = localStorage.getItem("user_id");
  }
  /**
   * ログイン処理
   */
  login() {
    this.authService.auth(this.data).subscribe(
      (data) => {

        this.authStore.token = data.token; //トークン設定
        this.authStore.logedIn = data.user; //ログインユーザ設定

        localStorage.setItem("user_id", this.data.user_id);
        localStorage.setItem("token", data.token);

        //ログイン成功処理
        this.loginSuccess()
      },
      (error) => {
        // super.alert(this.alertController, "ログイン情報に誤りがありました");
        // this.navCtrl.setRoot(TabsPage);
      }
    );
  }

  /**
   * ログイン成功処理
   */
  loginSuccess() {

    //定数情報取得
    this.httpConstantProvider.getList().subscribe((data) => {
      this.constantsStore.data = data.data;
      this.setRoot(this.navCtrl, TabsPage);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts